const debug = require("debug");

module.exports = debug("default");
